import React, { FC } from 'react';

// components
import BasicButton from '../../components/buttons/basicButton';
import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

import useRoleFlags from 'hooks/auth/useRoleFlags';

interface FormulaCatalogActionsProps {
    handleCreateMessageClick: () => void;
}

const FormulaCatalogActions: FC<
    React.PropsWithChildren<FormulaCatalogActionsProps>
> = ({ handleCreateMessageClick }) => {
    const { hasCreateFormulaAccess } = useRoleFlags();
    return (
        hasCreateFormulaAccess && (
            <Container>
                <BasicButton
                    name={'Create message'}
                    isPrimary
                    action={handleCreateMessageClick}
                />
            </Container>
        )
    );
};

const Container = styled.div(() => ({
    display: 'flex',
    gap: aampeTheme.spacing(1),
    alignItems: 'center',
}));

export default FormulaCatalogActions;
